import React from 'react'
import Paper from 'material-ui/Paper';

import { settings as ROLES_CONFIG } from '../../../../config/roles';

import AlertSetting from '../../../../components/settings/AlertSetting';

export default class Settings extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.alertSettings.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 col-11 ml-3-2vw mt-1vw p-0 h-100 customShadow" zDepth={3}>
                <AlertSetting />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/settings/Settings.js